export interface ClareProcessStep {
    id: number;
    text: string;
    tag?: string;
    description?: string;
    isCompleted?: boolean;
    isActive?: boolean;
    isTouched?: boolean;
}

export const activeStep = (steps: ClareProcessStep[], activeIndex = 0, previousIndex = -1) => {
    if (previousIndex > -1) {
        steps[previousIndex].isCompleted = true;
    }
    steps.forEach((step, index) => {
        step.isActive = index === activeIndex;
        if (index === activeIndex) {
            step.isTouched = true;
        }
    });
};

export const getStepByTag = (steps: ClareProcessStep[], tag: string) => steps.find(step => step.tag === tag);

export const getStepIndexByTag = (steps: ClareProcessStep[], tag: string) => steps.findIndex(step => step.tag === tag);
